import { TimerIcon, MapPinIcon, AwardIcon, LeafIcon, type LucideIcon } from "lucide-react";

export type Engagement = { icon: LucideIcon; title: string; text: string };

export const engagements: Engagement[] = [
  {
    icon: TimerIcon,
    title: "Réactivité et proximité",
    text: "Une équipe d'experts joignable, qui vous suit du premier échange à la remise des clés.",
  },
  {
    icon: MapPinIcon,
    title: "Aménagement local",
    text: "Tout est conçu et réalisé dans notre atelier, en plein cœur du Pays Basque.",
  },
  {
    icon: AwardIcon,
    title: "Équipe qualifiée",
    text: "Des professionnels spécialisés dans l'aménagement de vans et l'homologation VASP.",
  },
  {
    icon: LeafIcon,
    title: "Éthique environnementale",
    text: "Matériaux durables, fournisseurs choisis et chutes valorisées à l'atelier.",
  },
];
